import React, { Component } from 'react';
import './switches.css';

class SwitchSVG extends Component {

  constructor(props) {
    super(props);

    this.state = {on : false,
		  x2 : 30};

    this.update = function() {
      if(this.state.on) {
	this.setState( {bulbColor: 'yellow',
			contactX2: 100,
			binDigit:  1,
			decColor:  'red'});

	this.props.updateWords(this.props.placeValue);
	
      } else {
	this.setState( {bulbColor: 'white',
			contactX2: 30,
			binDigit:  0,
			decColor:  '#bbb'});
	this.props.updateWords(-this.props.placeValue);

      }

    }
  }

  
  handleClick(e) {
    e.preventDefault();
    // supposed to use setState, but this leads to negative numbers
    //this.setState({on : !this.state.on});
    this.state.on = !this.state.on;
    this.update();
  }

  
  render() {
    return (

<div id={'switchDIV' +this.props.placeValue}>

  <div className='decimalDigit' style={{color:this.state.decColor}}>{this.props.placeValue}</div>

    <div className='binaryDigit'>{this.state.binDigit||0}</div>

  <svg xmlns="http://www.w3.org/2000/svg"
       baseProfile="tiny"
       viewBox="0 0 200 500" 
	onClick={(e) => this.handleClick(e)} >

<line x1="100" x2="100" y1="500" y2="350"  />

<line x1="100" x2={this.state.contactX2 || 30} y1="350" y2="180"  />

<circle cx="100" cy="150" r="30" style={{fill:this.state.bulbColor}} />

<circle cx="100" cy="350"  r="30" />

  </svg> 
</div>

    )
  }
}


class App extends Component {
  state = { decimalWord:'00',
	    hexadecimalWord:0 };

  updateWords = (num) => {
    let newSum = Number(this.state.decimalWord) + Number(num);
    this.setState({decimalWord: newSum.toString().padStart(2,0),
		   hexadecimalWord: newSum.toString(16).toUpperCase()});

  }
  
  render() {
    return (<div id="switchesDIV">
	    <SwitchSVG placeValue="8" updateWords={this.updateWords} />
	    <SwitchSVG placeValue="4" updateWords={this.updateWords} />
	    <SwitchSVG placeValue="2" updateWords={this.updateWords} />
	    <SwitchSVG placeValue="1" updateWords={this.updateWords} />
	    <table>     
	    <tr> <th>decimal</th> <td id="fullDecimalNum"><span>{this.state.decimalWord}</span></td> </tr>
	    <tr> <th>hexadecimal</th> <td id="hexNum"><span>{this.state.hexadecimalWord}</span></td> </tr>
	    </table>
	    </div>)}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js